import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {gsap} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../../components/BasicBitmapCountUp";
import {TrueGritGameAssets} from "../../TrueGritGameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {TrueGritSound} from "../../sound/TrueGritSound";

/**
 * Class description
 *
 * Created: 2021-11-18
 * @author jonas
 */
export class TrueGritOutroView extends PIXI.Container implements StageLayer {
    private _outroContainer:PIXI.Container;
    private _button:ContinueButton;
    private _clickCallback:Function;
    private countUp:BasicBitmapCountUp;
    protected _background:PIXI.Sprite;

    constructor() {
        super();
        this.init();
    }

    protected getOutroContent():PIXI.Container {
        return new PIXI.Container();
    }

    private init() {
        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0x000000;
        this._background.alpha = 0;
        this.addChild(this._background);

        this._outroContainer = this.getOutroContent();
        this._outroContainer.alpha = 0;
        this.addChild(this._outroContainer);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.position.set(360, 615);
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false);
        this._button.alpha = 0;


        this.countUp = new BasicBitmapCountUp({
            fontName:TrueGritGameAssets.BITMAP_FONT_WIN_NUMBERS,
            fontSize:190,
            tint:0xffffff
        }, 720, new PIXI.Point(0.5, 0.5));
        this.countUp.position.set(0, 0);
        this.countUp.scale.set(0.8, 0.8);
        this.countUp.stopAt(0);
        this.countUp.position.set(360, this.getCountUpYPos());
        this.countUp.alpha = 0;
        this.addChild(this.countUp);
        this.addChild(this._button);


        this.onResize();
    }

    private onButtonClick() {
        this._button.enable(false);
        this._clickCallback();
    }

    public hideOutro(isWinBelowStake:boolean):gsap.core.Timeline {
        const tl = gsap.timeline();
       // tl.add(gsap.to(this._background, {duration:0.2, alpha:1}));
        tl.add(() => {
            TrueGrit.backgroundElements.setMode(TrueGritGameMode.NORMAL, 2);
            TrueGrit.foregroundElements.setMode(TrueGritGameMode.NORMAL, 2);
            TrueGrit.reelBackgroundView.setMode(TrueGritGameMode.NORMAL, 2);
            TrueGrit.symbolBoxView.currentLockLevel = 4;
            TrueGrit.symbolBoxView.restoreLockedWild = true;
            TrueGrit.keypadPlugin.setWin(TrueGrit.model.accumulatedRoundWin, true, isWinBelowStake);
        });
        tl.add(gsap.to(this._outroContainer, {duration:1.0, alpha:0}));
        tl.add(gsap.to(this._background, {duration:1.0, alpha:0}), "<");
        tl.add(gsap.to(this._button, {duration:0.4, alpha:0}), "<");
        tl.add(gsap.to(this.countUp, {duration:0.4, alpha:0}), "<");

        tl.add(() => {
            NolimitApplication.removeLayer(this.name);

            TrueGrit.model.buyFeatureName = "";
        })
        return tl;
    }


    onResize():void {
        const bounds:ScreenBounds = NolimitApplication.screenBounds;
        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if(NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom-80);
        }


        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.x = NolimitApplication.screenBounds.left;
        this._background.y = NolimitApplication.screenBounds.top;
    }


    public showButton():gsap.core.Timeline {
        const tl:gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => this._button.enable(true));
        tl.add(gsap.to(this._button, {duration:0.2, alpha:1}));
        return tl;
    }

    public getCountUp(amount:number, countDuration:number = 2, isWinBelowStake:boolean):gsap.core.Timeline {
        const tl:gsap.core.Timeline = new gsap.core.Timeline();

        if (isWinBelowStake) {
            countDuration = 0;
        }

        if (countDuration > 0) {
            tl.add(() => TrueGrit.soundPlayer.startCountUp());
            tl.add(this.countUp.getCountAnimation(0, amount, countDuration));
            tl.add(() => {
                TrueGrit.soundPlayer.stopCountUp(undefined,false);

                // #511
                this.countUp.stopAt(amount);
            });
            tl.add(()=> {TrueGrit.soundPlayer.playSound(TrueGritSound.COUNT_UP_END_FS)});
        } else {
            tl.add(() => this.countUp.stopAt(amount));
        }

        tl.add(gsap.to(this.countUp, {duration:0.6, alpha:1}), 0);
        tl.add(() => TrueGrit.keypadPlugin.setWin(amount, true, isWinBelowStake));

        return tl;
    }

    public showOutro(callback:Function, isCapWin:boolean = false):gsap.core.Timeline {
        this.countUp.position.y = this.getCountUpYPos();
        this._clickCallback = callback;
        const tl:gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => this.onResize());
        tl.add(() => NolimitApplication.addLayer(this.name, this));

        if (isCapWin){
            tl.add(gsap.to(this._outroContainer, {duration:0.6, alpha:1}));
            tl.add(gsap.to(this._background, {duration:0.6, alpha:0.7}));
        }else {
            tl.add(gsap.to(this._background, {duration:0.6, alpha:0.7}));
            tl.add(gsap.to(this._outroContainer, {duration:0.6, alpha:1}));
        }

        return tl;
    }

    protected getCountUpYPos() {
        return 562;
    }
}